import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
// import { API_URL } from '../../config/config';

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get token from Redux state or session/local storage
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

// Async thunk to fetch all users
export const fetchAllUsers = createAsyncThunk(
  'users/fetchAllUsers',
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(`${API_URL}/users/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('Failed to fetch users:', error);
      return rejectWithValue(error.response?.data || 'Failed to fetch users');
    }
  }
);

export const updateUser = createAsyncThunk(
  'users/updateUser',
  async ({ userId, userData }, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.put(`${API_URL}/users/updateUser/${userId}`, userData, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('failed to update user:', error);
      return rejectWithValue(error.response?.data || 'failed to update user');
    }
  }
);

export const deleteUser = createAsyncThunk(
  'users/deleteUser',
  async (userId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.delete(`${API_URL}/users/deleteUser/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('failed to delete user:', error);
      return rejectWithValue(error.response?.data || 'failed to delete user');
    }
  }
);

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearUsers: (state) => {
      state.users = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.users.findIndex(user => user.user_id === action.payload.user_id);
        if (index !== -1) {
          state.users[index] = action.payload;
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users = state.users.filter(user => user.user_id !== action.payload.user_id);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearUsers } = usersSlice.actions;
export default usersSlice.reducer;



// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
// // import { API_URL } from '../../config/config';

// const API_URL = process.env.REACT_APP_API_URL;

// // Async thunk to fetch all users
// export const fetchAllUsers = createAsyncThunk(
//   'users/fetchAllUsers',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}/users/users`);
//       return response.data;
//     } catch (error) {
//       console.error('Failed to fetch users:', error); // Log error for debugging
//       return rejectWithValue(error.response?.data || 'Failed to fetch users');
//     }
//   }
// );

// export const updateUser = createAsyncThunk(
//   'users/updateUser',
//   async({userId,userData},{rejectwithvalue}) =>{
//     try{
//       const response = await axios.put(`${API_URL}/users/updateUser/${userId}`,userData);
//       return response.data;
//     } catch (error) {
//       console.error('failed to update user:',error);
//       return rejectwithvalue(error.response?.data||'failed to update user');
//     }
//   }
// );

// export const deleteUser = createAsyncThunk(
//   'users/deleteUser',
//   async(userId,{rejectwithvalue}) =>{
//     try{
//       const response = await axios.delete(`${API_URL}/users/deleteUser/${userId}`);
//       return response.data;
//     } catch (error) {
//       console.error('failed to delete user:',error);
//       return rejectwithvalue(error.response?.data||'failed to delete user');
//     }
//   }
// );

// // Create the users slice
// const usersSlice = createSlice({
//   name: 'users',
//   initialState: {
//     users: [],       // List of users
//     loading: false,  // Indicates loading state
//     error: null,     // Stores any errors
//   },
//   reducers: {
//     clearUsers: (state) => {
//       state.users = []; // Clears the user data
//       state.error = null;
//       state.loading = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAllUsers.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchAllUsers.fulfilled, (state, action) => {
//         state.loading = false;
//         state.users = action.payload; // Store fetched users
//       })
//       .addCase(fetchAllUsers.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload; // Capture error message
//       })
//       /* update user */
//       .addCase(updateUser.pending,(state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateUser.fulfilled, (state, action) => {
//         state.loading = false;
//         const index = state.users.findIndex(user => user.user_id === action.payload.user_id);
//         if (index !== -1) {
//           state.users[index] = action.payload;
//       }})
//       .addCase(updateUser.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//        /* delete user */
//       .addCase(deleteUser.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteUser.fulfilled, (state, action) => {
//         state.loading = false;
//         state.users = state.users.filter(user => user.user_id !== action.payload.user_id);
//       })
//       .addCase(deleteUser.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//    },
// });

// // Export actions and reducer
// export const { clearUsers } = usersSlice.actions;
// export default usersSlice.reducer;
